export default __webpack_public_path__ + "static/media/whyChooseUsIcon1.cb7c10f0.webp";